import { Injectable } from "@angular/core";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse, PlutosRequest } from "@tendercuts/models";
import { LoginServices } from "../login";
import { EndPoint } from "../base";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class PinelabsUploadTxnService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get model() {
    return GenericServerResponse;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get endpoint() {
    return this.endpointService.pinelabsUploadTxnEndpoint();
  }

  /**
   * @override
   * Disable caching for this service
   */
  get isCachable() {
    return false;
  }

  getParams(type: string, transactionData: PlutosRequest) {
    let params = {
        type: type,
        transaction_data: transactionData
    } 
    return params;
  }
}
